import { Api } from '@/services/api'

export const getProductCategories = async (token) =>
	// eslint-disable-next-line implicit-arrow-linebreak
	Api(token).get('/V1/Product/GetProductCategories')

export default undefined
